import React, { useState } from 'react';
import styles from 'styles/components/PreviewAndSend.module.css';
import { useSurveyContext } from 'contexts/SurveyContext';
import SurveyComplete from './SurveyComplete';
import { launchSurvey } from 'rest/makeSurveyClient';
import { RestError } from '@ax2/common/rest/baseClient';
import { history } from '../helpers/router';
import { useErrorUpdateContext } from '@ax2/common/contexts/ErrorContext';
import Modal from '@ax2/common/components/Modal';
import { ActionButton } from '@ax2/common/components/ActionButton';
import { getErrorMessage, SurveyErrorReason } from '@ax2/common/helpers/error';
import Loading from '@ax2/common/components/Loading';
import DefaultPage from 'pages/DefaultPage';

export const LaunchSurvey: React.FC = () => {
  const surveySchema = useSurveyContext();
  const updateError = useErrorUpdateContext();
  const [isSaving, setIsSaving] = useState(false);
  const [isLaunched, setIsLaunched] = useState(false);
  const handleFinish = () => {
    history.push('/dashboard');
  };
  return surveySchema ? (
    <div
      style={{
        margin: '0px',
        padding: '0px',
      }}
    >
      {isLaunched && (
        <Modal onClose={handleFinish}>
          <div className={styles.modalContent}>
            <span className={styles.launchCongrat}>
              Your survey is launched!
            </span>
            <span className={styles.launchInfo}>
              Launched surveys can be accessed by selecting
              <b> Sent/Active Surveys</b> tab on the Dashboard page.
            </span>
            <ActionButton text="Go to Dashboard" onClick={handleFinish} />
          </div>
        </Modal>
      )}
      <DefaultPage
        header={{
          title: 'Survey Launch',
          subtitle: 'This is where you can launch your surveys.',
        }}
        wideContent={true}
      >
        <SurveyComplete
          surveyName={surveySchema.title ? surveySchema.title : ''}
          panel={surveySchema.panel}
          loading={isSaving}
          complete={{
            title: 'Send Panel Survey',
            onAction: async () => {
              setIsSaving(true);
              try {
                await launchSurvey(surveySchema.id);
                setIsSaving(false);
                setIsLaunched(true);
                sessionStorage.clear();
              } catch (e) {
                const restError = e as RestError;
                setIsSaving(false);
                updateError({
                  text: getErrorMessage(restError),
                  actions:
                    restError.reason === SurveyErrorReason.NoAvailableSurveySlot
                      ? [
                          {
                            text: 'Shop Panel Surveys',
                            onClick: () => {
                              history.push('/purchase');
                            },
                          },
                        ]
                      : [],
                });
              }
            },
          }}
          QuotaStatus={false}
        />
      </DefaultPage>
    </div>
  ) : (
    <Loading paddingVertical={25} />
  );
};
